 
import Layout from './Layout.js';
import Box from '@mui/material/Box';
import Bindcomponent from '../utils/bindcomponent.js';
import { useEffect, useState } from "react";
import { Navigate, useNavigate,useParams } from "react-router-dom";
import AxiosFetchData from "./AxiosFetchData";
import { CatchWrapperAsync } from "../utils/catchwrapper";
import DatePicker from 'react-datepicker';
import ProductDialog from "../components/ProductDialog.js"; 
import Projectdetail from '../components/ProjectDetail.js';
import CustomDialog from '../components/Dialog.js';
import DynamicSelect from '../components/DynamicSelect.js';
const RequestMaterialAdd = () => {
    const navigate = useNavigate()
    const {id} = useParams()

    const [descriptions,setDescription] = useState('')
    const [requestDate,setRequestDate] = useState(Date.now())
    const [dueDate,setDueDate] = useState(Date.now())
    const [rows,setRows] = useState([])
    const [productopen,setproductopen] = useState(false)
    const [itemopen,setitemopen] = useState(false)
    const [message,setmessage] = useState('')
    const [tipe,settipe] = useState('')
    const [userID,setUserID] = useState(0)
    const [roleAccess,setRoleAccess] = useState({})
    const [selectedOpt,setSelectedOpt] = useState({})
    const [customProduct,setCustomProduct] = useState({
        product_name : '',
        product_qty : 0,
        product_unit : {},
        product_hpp : 0
    })

    useEffect(()=>{
        fetch()
    },[])

    const fetch = async () => {
        const response = await AxiosFetchData.token().refreshToken()
        console.log(response)
      //  setRoleAccess(response.roleaccess)
        setUserID(response.userID)
    }

    const columns = [
        { field: 'rowNumber', headerName: 'No.', width: 80 },
        // { field: 'product_id', headerName: 'Product ID', width: 150 },
        { field: 'product_name', headerName: 'Product Name', width: 250},
        { field: 'unit_id', headerName: 'Unit ID', width: 100},
        
        {
          field: 'actions',
          headerName: 'Qty',
          width: 100,
          renderCell: (params) => (
            <>
                   <input
                                type="number"
                                value={params.row.qty}
                                name="txtQty"
                                min={0}
                                onChange={(e) => handleQty(e.target.value, params.row)}
                                className='form-control'
                                required
                            />
          
            </>
            
          ),
        },
        { field: 'last_buy_price', headerName: 'Price', width: 150},
         { field: 'cost', headerName: 'Total Price', width: 150},
        {
          field: 'actions2',
          headerName: 'Actions',
          width: 250,
          renderCell: (params) => (
            <>
            
          <button type='button'
                onClick={() =>
                               {
                                        handleDelete(params.row.id)
                                         
                                } }  
                                      className="btn btn-info"
                                     
                                >
                                       Delete
        </button>
          
            </>
            
          ),
      },
      ];

      const handleDelete = (id) => {
        setRows((prev)=> prev.filter((item)=> item.id != id));
      }

      const handleProduct = (item)=>{
        const isExist = rows.find((data) => data.product_id == item.product_id)
        if(isExist != null){
            setmessage(`Item ${isExist.product_name} already exist in list`)
            settipe("error")
            return;
        }

        setRows((prev)=> [...prev,{...item,id: Math.random(), cost : item.qty * item.last_buy_price,line : prev.length + 1}].map((item,index)=>({
            ...item,    
            rowNumber : index + 1
        })))
      }

      const handleQty = (value, item) => {
        
        const newRowsList = [...rows];
        const row = newRowsList.find((data)=> data.id == item.id)
        
        if(row!=null){
            row.qty = value
            row.cost = row.qty * row.last_buy_price
        }

        setRows(newRowsList);

      }

    const handleSubmit = async (e) => { 
        e.preventDefault();
        CatchWrapperAsync(async() => {
                var data = {
                    descriptions : descriptions,
                    request_date : requestDate,
                    due_date : dueDate,
                    project_id : id,
                    status : 1,
                    created_by : userID,
                    updated_by : userID,
                    detail : rows
                }

                const response = await AxiosFetchData.post(`CreateMaterialRequest`, data).refreshToken(navigate,"requestmaterial")
                if(response.data.result){
                    //setmessage(response.data.message)
                }

                await AxiosFetchData.post(`SendPushNotification`,{title: "NEW MATERIAL REQUEST", message: "Please follow up material request", to:["PM"]}).refreshToken(navigate,"requestmaterial")

                document.getElementById("btnBack").click();
        },setmessage, settipe)
    }

    const handleCustomProduct = (e) => {
        e.preventDefault()
         setitemopen(false);

           setRows((prev)=> [...prev,{product_id :  Math.random().toString().split(".")[1].substring(0,4) * -1, product_name : customProduct.product_name,unit_id : customProduct.product_unit.value,id: Math.random(), last_buy_price : customProduct.product_hpp,qty : customProduct.product_qty,cost : customProduct.product_qty * customProduct.product_hpp,line : prev.length + 1}].map((item,index)=>({
            ...item,    
            rowNumber : index + 1
        })))
    }

    return (
        <>
            <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
                <div className='pd' ><b> REQUEST MATERIAL ADD</b></div>
 
                <div className="pd">
                    <form onSubmit={handleSubmit}>
                    <Projectdetail id={id} message={setmessage} tipe={settipe} roleaccess={setRoleAccess}></Projectdetail>
                     <Box>
                        <div style={{marginBottom:10}} >
                            <label>Description</label>
                            <div>
                                 <input
                                type="text"
                                value={descriptions}
                                name="txtdesc"
                                onChange={(e) => setDescription(e.target.value)}
                                className='form-control'
                                required
                            />
                            </div>
                           
                        </div>
                        
                   
                   
                        <div style={{marginBottom:20}}>
                            <label style={{display:"inline-block"}}>Request Date</label>
                            <div>
                                <DatePicker 
                                            showIcon
                                            selected={requestDate}
                                             onChange={(date) => setRequestDate(date)}
                                           // disabled={!roleAccess.UPDATE}
                                             
                                            dateFormat="dd-MM-yyyy"
                                            className="form-control"/>
                            </div>
                          
                        </div>

                         <div style={{marginBottom:40}}>
                            <label style={{display:"inline-block"}}>Due Date</label>
                            <div>
                                <DatePicker 
                                            showIcon
                                            selected={dueDate}
                                             onChange={(date) => setDueDate(date)}
                                           // disabled={!roleAccess.UPDATE}
                                             
                                            dateFormat="dd-MM-yyyy"
                                            className="form-control"/>
                            </div>
                          
                        </div>
                   </Box>
                    <button type="button" style={{marginBottom:10,marginRight:10}}  
                        onClick={() =>
                               {
                                         setproductopen(true);
                                         
                                } }  
                                      className="btn btn-primary"
                                     
                                >
                                       + PRODUCT
                    </button>
                     <button type="button" style={{marginBottom:10}}  
                        onClick={() =>
                               {
                                         setitemopen(true);
                                         
                                } }  
                                      className="btn btn-primary"
                                     
                                >
                                       + CUSTOM PRODUCT
                    </button>
                    <Box sx={{ width: 1 }} >
                    <Box sx={{ height: "100%" }} >
                        <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} rowid={"id"} name="rakapprovalgrid" ></Bindcomponent>
                    </Box>
                    </Box>
                    <div style={{textAlign:"right"}}>
                                <button  style={{marginTop:10}} disabled={!roleAccess.CREATE}  
                                    type="submit"
                                      className="btn btn-primary"
                                     
                                >
                                       CREATE
                    </button>
                    </div>
                    </form>
                </div>
                <CustomDialog title={"ADD CUSTOM PRODUCT"} setOpen={setitemopen} open={itemopen} maxWidth='sm' >
                   <form onSubmit={handleCustomProduct}>
                   <div style={{marginBottom:10}}>
                                 <label>Product Name</label>
                                <input
                                type="text"
                                value={customProduct.product_name}
                                name="txtItemName"
                               // min={0}
                                onChange={(e) => setCustomProduct((prev) => ({...prev, product_name: e.target.value}))}
                                className='form-control'
                                required
                            />
                   </div>
                       <div style={{marginBottom:10}}>
                                 <label>Product Unit</label>
                                <DynamicSelect url={"GetUnits"} label="{id} - {name}" value={"id"} selectedvalue={customProduct.product_unit} onChange={(opt) => setCustomProduct((prev) => ({...prev, product_unit : opt}))} ></DynamicSelect>
                   </div>
                   <div style={{marginBottom:10}}>
                                <label>Product Qty</label>
                                <input
                                    type="number"
                                value={customProduct.product_qty}
                                name="txtItemQty"
                                min={0}
                               onChange={(e) => setCustomProduct((prev) => ({...prev, product_qty: e.target.value}))}
                                className='form-control'
                                required
                            />
                   </div>
                     <div style={{marginBottom:10}}>
                                <label>Price</label>
                                <input
                                    type="number"
                               value={customProduct.product_hpp}
                                name="txtItemHpp"
                                min={0}
                                onChange={(e) => setCustomProduct((prev) => ({...prev, product_hpp: e.target.value}))}
                                className='form-control'
                                required
                            />
                   </div>
                   <div>
                       <button type="submit" style={{marginBottom:10}}  
                      
                                      className="btn btn-primary"
                                     
                                >
                                       + ADD
                    </button>          
                   </div>
                 </form>
                </CustomDialog>      
                <ProductDialog productclose={setproductopen} productopen={productopen} handleProductDialog={(item)=> handleProduct(item)}></ProductDialog>
            </Layout>
        </>
    )

}
export default  RequestMaterialAdd